import { Button } from "../components/index.ts";

/**
 * The bar of "New swimmers" (link-parents-sync): the names the owner linked to a parent, the names
 * with an answer from a parent to check (`check`, part of `waiting`), and the names that still
 * wait. The page and Home show the same bar.
 */
export function LinkProgressBar({
  linked,
  waiting,
  check = 0,
  participants,
  member,
  onShowWaiting,
  onShowCheck,
}: {
  linked: number;
  waiting: number;
  /** Waiting names with an answer from a parent or a coach to check. */
  check?: number;
  /** The business words: plural participants ("swimmers") and one member ("parent"). */
  participants: string;
  member: string;
  onShowWaiting?: () => void;
  onShowCheck?: () => void;
}) {
  const total = linked + waiting;
  const share = total === 0 ? 0 : Math.round((linked / total) * 100);
  const checkShare = total === 0 ? 0 : Math.round((Math.min(check, waiting) / total) * 100);
  const find = waiting - Math.min(check, waiting);
  return (
    <div className="flex flex-col gap-2">
      <progress className="sr-only" aria-label={`${participants} linked to a ${member}`} value={linked} max={Math.max(total, 1)} />
      <div className="flex h-2.5 overflow-hidden rounded-full bg-sunken" aria-hidden="true">
        <div className="h-full bg-confirmed transition-[width] duration-500 motion-reduce:transition-none" style={{ width: `${share}%` }} />
        {checkShare > 0 ? <div className="h-full bg-whatsapp transition-[width] duration-500 motion-reduce:transition-none" style={{ width: `${checkShare}%` }} /> : null}
      </div>
      <p className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[13px] text-ink-2">
        <span>
          <span className="mr-1.5 inline-block h-2 w-2 rounded-full bg-confirmed" aria-hidden="true" />
          <b className="text-ink tabular-nums">{linked}</b> linked
        </span>
        {check > 0 ? (
          <span>
            <span className="mr-1.5 inline-block h-2 w-2 rounded-full bg-whatsapp" aria-hidden="true" />
            {onShowCheck ? (
              <Button variant="ghost" size="sm" readOnlySafe onClick={onShowCheck} className="-my-1 px-2">
                {check} answered by a {member}, check them
              </Button>
            ) : (
              <>
                <b className="text-ink tabular-nums">{check}</b> to check
              </>
            )}
          </span>
        ) : null}
        <span>
          <span className="mr-1.5 inline-block h-2 w-2 rounded-full bg-line-strong" aria-hidden="true" />
          {onShowWaiting && find > 0 ? (
            <Button variant="ghost" size="sm" readOnlySafe onClick={onShowWaiting} className="-my-1 px-2">
              {find} to find. Show them
            </Button>
          ) : (
            <>
              <b className="text-ink tabular-nums">{find}</b> to find
            </>
          )}
        </span>
      </p>
    </div>
  );
}
